import CategoryPage from "./CategoryPage";
import ItemListPage from "./ItemListPage";

// Hero banner from CategoryPage stacked on top of the generic listing.
// Used by Military / Wildfire / Hunting / Everyday so they share one shape.
export default function CategoryListing({ title, description, image, productLine }) {
  return (
    <>
      <CategoryPage title={title} description={description} image={image} />
      <ItemListPage productLine={productLine} />
    </>
  );
}
